import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _381f8064 = () => interopDefault(import('../../../pages/contact-opnemen/index.vue' /* webpackChunkName: "pages/contact-opnemen/index" */))
const _bbd1d8ea = () => interopDefault(import('../../../pages/contact-opnemen-bedrijf/index.vue' /* webpackChunkName: "pages/contact-opnemen-bedrijf/index" */))
const _13e2dec4 = () => interopDefault(import('../../../pages/informatie-over-zonnepanelen/index.vue' /* webpackChunkName: "pages/informatie-over-zonnepanelen/index" */))
const _39ecc3cc = () => interopDefault(import('../../../pages/contact-opnemen-bedrijf/bevestigd.vue' /* webpackChunkName: "pages/contact-opnemen-bedrijf/bevestigd" */))
const _ec5dc7b6 = () => interopDefault(import('../../../pages/contact-opnemen/bevestigd.vue' /* webpackChunkName: "pages/contact-opnemen/bevestigd" */))
const _82c65a0a = () => interopDefault(import('../../../pages/informatie-over-zonnepanelen/subsidies.vue' /* webpackChunkName: "pages/informatie-over-zonnepanelen/subsidies" */))
const _d4417f3c = () => interopDefault(import('../../../pages/informatie-over-zonnepanelen/zonne-energie.vue' /* webpackChunkName: "pages/informatie-over-zonnepanelen/zonne-energie" */))
const _f74511c2 = () => interopDefault(import('../../../pages/informatie-over-zonnepanelen/zonneboiler.vue' /* webpackChunkName: "pages/informatie-over-zonnepanelen/zonneboiler" */))
const _391b88b8 = () => interopDefault(import('../../../pages/informatie-over-zonnepanelen/zonnecollectoren.vue' /* webpackChunkName: "pages/informatie-over-zonnepanelen/zonnecollectoren" */))
const _3d7ebedb = () => interopDefault(import('../../../pages/informatie-over-zonnepanelen/zonnepanelen.vue' /* webpackChunkName: "pages/informatie-over-zonnepanelen/zonnepanelen" */))
const _270579e9 = () => interopDefault(import('../../../pages/offertes-aanvragen/aanvraag-afgerond.vue' /* webpackChunkName: "pages/offertes-aanvragen/aanvraag-afgerond" */))
const _558d6672 = () => interopDefault(import('../../../pages/offertes-aanvragen/soort-dak-schatting-jaarlijks-electriciteitsverbruik.vue' /* webpackChunkName: "pages/offertes-aanvragen/soort-dak-schatting-jaarlijks-electriciteitsverbruik" */))
const _572ee4b3 = () => interopDefault(import('../../../pages/offertes-aanvragen/type-opdracht.vue' /* webpackChunkName: "pages/offertes-aanvragen/type-opdracht" */))
const _4f418d1e = () => interopDefault(import('../../../pages/offertes-aanvragen/uw-gegevens.vue' /* webpackChunkName: "pages/offertes-aanvragen/uw-gegevens" */))
const _0505b622 = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))

const _861e7d2c = () => interopDefault(import('../../../../../shared/all/page/privacy/PrivacyPage.vue' /* webpackChunkName: "" */))
const _1c6fcb10 = () => interopDefault(import('../../../../../shared/all/page/cookies/CookiesPage.vue' /* webpackChunkName: "" */))
const _17f1aeb2 = () => interopDefault(import('../../../../../shared/all/page/termsAndConditions/TermsAndConditionsPage.be-nl.vue' /* webpackChunkName: "" */))
const _2b1ecb13 = () => interopDefault(import('../../../../../shared/all/themes/blueflow/page/ErrorPage.vue' /* webpackChunkName: "" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/contact-opnemen",
    component: _381f8064,
    name: "contact-opnemen"
  }, {
    path: "/contact-opnemen-bedrijf",
    component: _bbd1d8ea,
    name: "contact-opnemen-bedrijf"
  }, {
    path: "/informatie-over-zonnepanelen",
    component: _13e2dec4,
    name: "informatie-over-zonnepanelen"
  }, {
    path: "/contact-opnemen-bedrijf/bevestigd",
    component: _39ecc3cc,
    name: "contact-opnemen-bedrijf-bevestigd"
  }, {
    path: "/contact-opnemen/bevestigd",
    component: _ec5dc7b6,
    name: "contact-opnemen-bevestigd"
  }, {
    path: "/informatie-over-zonnepanelen/subsidies",
    component: _82c65a0a,
    name: "informatie-over-zonnepanelen-subsidies"
  }, {
    path: "/informatie-over-zonnepanelen/zonne-energie",
    component: _d4417f3c,
    name: "informatie-over-zonnepanelen-zonne-energie"
  }, {
    path: "/informatie-over-zonnepanelen/zonneboiler",
    component: _f74511c2,
    name: "informatie-over-zonnepanelen-zonneboiler"
  }, {
    path: "/informatie-over-zonnepanelen/zonnecollectoren",
    component: _391b88b8,
    name: "informatie-over-zonnepanelen-zonnecollectoren"
  }, {
    path: "/informatie-over-zonnepanelen/zonnepanelen",
    component: _3d7ebedb,
    name: "informatie-over-zonnepanelen-zonnepanelen"
  }, {
    path: "/offertes-aanvragen/aanvraag-afgerond",
    component: _270579e9,
    name: "offertes-aanvragen-aanvraag-afgerond"
  }, {
    path: "/offertes-aanvragen/soort-dak-schatting-jaarlijks-electriciteitsverbruik",
    component: _558d6672,
    name: "offertes-aanvragen-soort-dak-schatting-jaarlijks-electriciteitsverbruik"
  }, {
    path: "/offertes-aanvragen/type-opdracht",
    component: _572ee4b3,
    name: "offertes-aanvragen-type-opdracht"
  }, {
    path: "/offertes-aanvragen/uw-gegevens",
    component: _4f418d1e,
    name: "offertes-aanvragen-uw-gegevens"
  }, {
    path: "/",
    component: _0505b622,
    name: "index"
  }, {
    path: "*",
    redirect: {"path":"/"}
  }, {
    path: "/privacy",
    component: _861e7d2c,
    name: "privacy"
  }, {
    path: "/cookies",
    component: _1c6fcb10,
    name: "cookies"
  }, {
    path: "/algemene-voorwaarden",
    component: _17f1aeb2,
    name: "algemene-voorwaarden"
  }, {
    path: "/error",
    component: _2b1ecb13,
    name: "error"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
